import Cookies from 'js-cookie';

export default {
  data() {
    return {
      userLocation: Cookies.get('state')
    };
  },
  computed: {
    constraintTag() {
      return this.product.tags.filter(tag => tag.includes('constraint:'))[0];
    },
    hasHighABVTag() {
      return this.product.tags.includes('High ABV 6%+');
    },
    constraints() {
      const constraint = this.constraintTag.split(':')[1];
      return this.metafields.geoIpConstraints[constraint];
    },
    cannotConstraintProduct() {
      return !this.constraintTag || !this.constraints;
    },
    isNewHampshireAlcoholicProduct() {
      return this.hasHighABVTag && this.userLocation === 'NH';
    },
    canAddProduct() {
      if (this.isNewHampshireAlcoholicProduct) {
        return false;
      }

      if (this.cannotConstraintProduct) {
        return true;
      }

      return this.constraints.add_to_cart.includes(this.userLocation);
    },
    canFindInStore() {
      if (this.isNewHampshireAlcoholicProduct) {
        return false;
      }

      if (this.cannotConstraintProduct) {
        return true;
      }

      return this.constraints.find_in_store.includes(this.userLocation);
    },
    comingSoonText() {
      if (this.userLocation === 'Outside US') {
        return this.translations.outsideUS;
      }

      return this.translations.comingSoon;
    }
  },
  mounted() {
    this.$globalEventBus.addListener('location.set', data => {
      this.userLocation = data.state;
      if (this.afterLocationUpdate) {
        this.afterLocationUpdate();
      }
    });
  }
};
